<template>

  <header
    class="mdc-top-app-bar view-header"
    :style="
      surveyData.image
        ? `background-image: url(${surveyData.image}?s=360x256&t=fill&q=10&b=5);`
        : ''
    "
    :class="surveyData.image ? 'darken' : ''"
    v-if="surveyData"
  >
    <div class="mdc-top-app-bar__row">
      <section
        class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start"
      >
        <a
          class="material-icons mdc-top-app-bar__navigation-icon"
          @click="routerGoPrev1()"
          >arrow_back</a
        >
      </section>

      <section class="mdc-top-app-bar__section title">
        <div class="mdc-top-app-bar__title"></div>
      </section>

      <section
        class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end"
      >
        
      </section>
    </div>

    <div class="pdt-16 pdb-20 pdl-16 pdr-16">
      <div class="t-headline14">
        {{ surveyData.name }}
      </div>
      <div class="t-body4 mgt-8" v-if="surveyData.category">
        {{ surveyData.category.text }}
      </div>

      <div class="t-helper mgt-9 d-flex flex-row" v-if="surveyData && surveyData.tags && surveyData.tags.length">
      
        <div class="mdc-chip-set " role="grid">
          <div class="mdc-chip mdc-chip-outline" role="row"  v-for="(tag, index) in surveyData.tags"  :key="index">
              <div class="mdc-chip__ripple"></div>
              <span role="gridcell">
                  <span class="mdc-chip__text">#{{tag.name}}</span>
              </span>
          </div>
      </div>
      </div>

      <div class="mgt-21" v-if="surveyData && surveyData.point &&surveyData.point.totalPoint > 0">
        <div class="d-flex justify-content-between align-items-baseline">
          <span class="t-body3">{{ $t("1816") }}</span>
          <div
            class="d-flex justify-content-between align-items-center t-headline5"
          >
            <img
              src="@/assets/icon_point.svg"
              alt=""
              class="icon mgr-4 mgl-4"
            />
            {{ $n(surveyData.point.totalPoint) }}
          </div>
        </div>
      </div>
      <div v-else class="mgt-21">
        <div class="d-flex justify-content-between align-items-baseline">
          <span class="t-body3">{{ $t("1816") }}</span>
          <div
            class="d-flex justify-content-between align-items-center t-headline5"
          >
            <img
              src="@/assets/icon_point.svg"
              alt=""
              class="icon mgr-4 mgl-4"
            />
            {{ 0 }}
          </div>
        </div>
      </div>
        <div class="mgt-20">
          <button
            class="mdc-button mdc-button--raised btn-red w-full btn-big"
             @click="moveToDetail(surveyData.id)"
            v-if="surveyData && surveyData.progression && surveyData.progression.value === 'WAITING'"
          >
            {{ $t("1817") }}
          </button>
          <button
            class="mdc-button mdc-button--raised btn-red w-full btn-big"
             @click="moveToDetail(surveyData.id)"
            v-if="surveyData && surveyData.progression && surveyData.progression.value === 'APPLICATION'"
          >
            {{ $t("1817") }}
          </button>

          <button
            class="mdc-button mdc-button--raised btn-red w-full btn-big"
            @click="moveToDetail(surveyData.id)"
            v-if="surveyData && surveyData.progression && surveyData.progression.value === 'RESPONDENT'"
          >
            {{ $t("1817") }}
          </button>

          <button
            class="mdc-button mdc-button--raised btn-red w-full btn-big"
            @click="moveToDetail(surveyData.id)"
            v-if="surveyData && surveyData.progression && surveyData.progression.value === 'RESPONDING'"
          >
            {{ $t("1817") }}
          </button>
          <button
            class="mdc-button mdc-button--raised btn-red w-full btn-big"
            @click="moveToDetail(surveyData.id)"
            v-if="surveyData && surveyData.progression && surveyData.progression.value === 'SUBMITTED'"
          >
            {{ $t("1817") }}
          </button>

          <button
            class="mdc-button mdc-button--raised btn-red w-full btn-big"
             @click="moveToDetail(surveyData.id)"
            v-if="surveyData && surveyData.progression && surveyData.progression.value === 'NONRESPONSE'"
          >
           {{ $t("1817") }}
          </button>
        </div>

    </div>
  </header>

  
</template>

<script>
import httpService from "@/api/httpService";
// import loginApi from '@/api/loginApi.js'
import surveyApi from "@/api/surveyApi.js";
import {MDCRipple} from '@material/ripple'
import {MDCChipSet} from '@material/chips';
// Mixin 선언
import { surveyMixin } from "@/mixins/survey.js";

/*
WAITING 참여대기 참여 가능한 기간 이전 상태

APPLICATION 참여가능 참여 가능한 기간이지만 참여하지 않은 상태

RESPONDENT 응답가능 참여 후 아직 응답하지 않았지만 요청일이 응답일 내에 있는 상태

RESPONDING 응답중 응답기간 내에 설문 응답 시작을 하고 제출 이전

SUBMITTED 제출 설문을 제출한 상태

NONRESPONSE 미응시 설문 응시를 하지 않고 기간이 지난 상태
*/
export default {
  props: ["surveyData"],
  data() {
    return {
      authToken: "",
      distId: "",
      respondentId: "",
    };
  },

  mixins: [surveyMixin],

  mounted() {
    // console.log('authToken', this.authToken)
    this.setMaterialUi()
    const chipSetEl = document.querySelector('.mdc-chip-set');
    const chipSet = new MDCChipSet(chipSetEl);
  },

  updated() {
    this.authToken = localStorage.getItem("token");
    this.distId = this.surveyData.id;
    this.respondentId = this.surveyData.respondentId;
  },

  computed: {
    isAuthToken() {
      return !!this.authToken;
    },
  },

  methods: {
    moveLogin() {
      const loginPath = `/login?redirectPath=${encodeURIComponent(
        this.$route.fullPath
      )}`;
      this.$router.push(loginPath);
    },

    async takeSurvey(progression) {
      let authStatus = await this.checkLogin();
      if (authStatus) {
        console.log("중복체크",progression);

        if (progression === "APPLICATION") {
          let params = {
            distId: this.distId,
          };
          surveyApi.surveyIndependentEnter(params).then((response) => {
            this.respondentId = response.data.data.id;
            console.log("surveyIndependentEnter", response.data.data);
            this.moveSurveyIntro();
          });
        } else if (progression === "RESPONDENT") {
          this.moveSurveyIntro();
        } else if (progression === "RESPONDING") {
          this.moveSurveyIntro();
        } else if (progression === "SUBMITTED") {
          this.moveSurveyIntro();
        } else if (progression === "NONRESPONSE") {
        }
      } else {
        this.moveLogin();
      }
    },

    // checkLogin() {
    //     // httpService.setAuthInHeader(localStorage.getItem('token'))
    //     return new Promise((resolve, reject) => {
    //         loginApi.validToken().then((response) => {
    //             resolve(true)
    //         }).catch((err) => {
    //             resolve(false)
    //         })
    //     })

    // },

    moveLogin() {
      const loginPath = `/login?redirectPath=${encodeURIComponent(
        this.$route.fullPath
      )}`;
      this.$router.push(loginPath);
    },

    moveSurveyIntro() {
      let params = {
        distId: this.distId,
        respondentId: this.respondentId,
      };
      
      this.$router.push({
        name: "IndependentSurveyIntro",
        params: params,
      });
    },

    routerGoPrev1() {
      this.$router.push({
        name:'IndependentSurvey',
        params: this.$route.params,
        query: this.$route.query
      });
    },

    moveToDetail(id,type) {
        this.$router.push({
        name: "IndependentSurveyTotalView",
        params: { distId: id },
        query: {'listType':this.$route.query.listType,'viewDetail':'insightViewDetail'}
      });
     
    },
     
    setMaterialUi() {
      const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
          let button = new MDCRipple.attachTo(el)
          return button
      })
    },
  },
  
};
</script>
<style scoped>
  .mdc-tab-scroller {
            background: var(--Primary);
        }

        .mdc-tab-indicator .mdc-tab-indicator__content--underline {
            border-color: var(--WhiteHigh);
        }

        .headerSection img {
            filter: blur(8px);
        }

        .headerSection:after {
            position: absolute;
            content: "";
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.4);
        }

        .headerContent {
            z-index: 999;
            position: absolute;
            content: "";
            width: 100%;
            top: 0px;
            left: 0;
        }

        .survey-p {
            width: 24px;
            height: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            background-color: var(--Iconinactive);
        }

        .bg-iconInactiveText {
            background: var(--IconinactiveText) !important;
        }
</style>